'use client';

import { createContext, useContext } from 'react';

interface TwoColumnLayoutContextValue {
  isLeftOpen: boolean;
  toggleLeftSidebar: () => void;
}

export const TwoColumnLayoutContext = createContext<TwoColumnLayoutContextValue | undefined>(undefined);

/**
 * @description Hook to access the TwoColumnLayout sidebar toggle state and function.
 * Returns undefined if used outside of TwoColumnLayout.
 */
export const useTwoColumnLayout = (): TwoColumnLayoutContextValue | undefined => useContext(TwoColumnLayoutContext);
